import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-docx-skeleton',
  imports: [TranslateModule],
  templateUrl: './docx-skeleton.html',
  styleUrl: './docx-skeleton.scss',
})
export class DocxSkeleton {
  protected readonly lines = [100, 96, 88, 60, 100, 92, 72, 100, 98, 94, 40];
  protected readonly fields = [1, 2, 3, 4, 5, 6];
}
